import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';
import { SkeletonLine } from '../../ui/Skeleton/SkeletonLine';

// Mirrors one month of history: the heading above the table, the column header strip, then rows at the real row height.
export const HistoryTimelineSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
    <div data-testid="history-loading" aria-hidden="true" className="flex flex-col gap-s">
        <SkeletonLine lineClassName="text-s" className="w-24" />
        <div className="rounded-lg border border-line-card bg-surface-elevated shadow-weak overflow-hidden" data-testid="history-loading-table">
            <div className="flex items-center gap-m h-9 px-m md:px-l bg-surface-secondary" data-testid="history-loading-header">
                <SkeletonBar className="h-3 w-10 shrink-0" />
            </div>
            {Array.from({ length: rows }, (_, i) => (
                <div key={i} className="flex items-center gap-xl box-content h-10.75 px-m md:px-l border-t border-line-subtle" data-testid="history-loading-row">
                    <SkeletonBar className="h-3 w-20 shrink-0" />
                    <SkeletonBar className="hidden md:block h-3 w-1/4 shrink-0" />
                    <SkeletonBar className="h-3 flex-1" />
                    <SkeletonBar className="h-3 w-16 shrink-0" />
                </div>
            ))}
        </div>
    </div>
);
